import React from 'react';

import {WeightAvatar} from 'ccm/art/MedicalIcons';

import VitalCard from './VitalCard';

export default function WeightCard({patient, artifact}) {
    return (
        <VitalCard
            color='blue'
            Avatar={WeightAvatar}
            type='weight'
            patient={patient}
            {...artifact.attributes}
        >
            <h6>Weight</h6>
        </VitalCard>
    );
}
